import React, { useContext } from 'react'
import { TextField } from "@mui/material"
import { LoadingContext } from '../M_Utils'
import PropTypes from 'prop-types'

export function MTextArea({ label, value, required, disabled, color, secondColor, rows, helperText, onChange }) {

    const ctx = useContext(LoadingContext)
    color = color || ctx.primaryColor || 'var(--color-black)'
    secondColor = secondColor || ctx.secondaryColor || 'var(--color-black)'

    return (<TextField
        sx={{
            '& label': { color: 'var(--color-black)' },
            '& label.Mui-focused': { color: 'var(--color-black)' },
            '& .MuiInput-underline:after': { borderBottomColor: color },
            "& .MuiInputBase-root.Mui-disabled": {
                "& > fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.38) !important'
                }
            },
            '& .MuiOutlinedInput-root': {
                 backgroundColor: 'var(--color-white)', 
                '& fieldset': {
                    borderColor: color,
                },
                '&:hover fieldset': {
                    borderColor: color,
                },
                '&.Mui-focused fieldset': {
                    borderColor: color,
                }
            }
        }}
        margin="dense"
        required={required}
        disabled={disabled}
        fullWidth
        variant="outlined"
        slotProps={{
            inputLabel: { autoComplete: "none", shrink: true }
        }}
        label={label}
        value={value}
        onChange={onChange}
        multiline
        rows={rows || 3}
        helperText={helperText}
    />
    )
}

MTextArea.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    secondColor: PropTypes.string,
    rows: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    helperText: PropTypes.node,
    onChange: PropTypes.func
}